import { Component, Inject, OnInit } from '@angular/core';
import { zip, forkJoin, Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { HoldersCvfMaterialDialogComponent } from '../holders-cvf-material-dialog/holders-cvf-material-dialog.component';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import {
  CvfControllerService,
  CvfCodLerOperacionControllerService,
  CvfMaterialesCodLerControllerService,
  CvfMermasControllerService,
  CodigosLerMaterialControllerService,
  CvfOperacionDestinoFinalControllerService
} from 'api-rest';
import { DatePipe } from '@angular/common';
import { DownloadService } from '../../../services/download.service';
import { HoldersCvfImageDetailComponent } from '../holders-cvf-image-detail/holders-cvf-image-detail.component';
import { HoldersCvfSignedUploadDialogComponent } from '../holders-cvf-signed-upload-dialog/holders-cvf-signed-upload-dialog.component';

@Component({
  selector: 'lib-holders-cvf-detail',
  templateUrl: './holders-cvf-detail.component.html',
  styleUrls: ['./holders-cvf-detail.component.scss']
})
export class HoldersCvfDetailComponent implements OnInit {
  id!: number;
  private sub: any;
  public searchFormState: any;
  cvfData!: any;
  fechaFinCvf: any;
  cvfCodigosLerOperacion: any = [];
  userRole: string = 'PO_GESTOR';
  isEditable: boolean = false;
  confirmacionFinal: boolean = false;

  materialesPrincipales: any[] = [];
  materialesAgrupacion: any[] = [];
  operacionesGestion: any[] = [];
  operacionesDestinoFinal: any[] = [];

  cambiosSinGuardar: boolean = false;
  datosGestorModificados: boolean = false;
  combinacionEnEdicion: number | null = null;
  pageNumber: number = 0;
  pageSize: number = 25;
  combinacionOriginal: any = null;

  get styleEstado() {
    switch (this.cvfData?.estado.id) {
      case 1: return { 'background-color': '#5FC3E1  ', 'color': '#ffffff' };
      case 2: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 3: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 4: return { 'background-color': '#5FC3E1    ', 'color': '#ffffff' };
      case 5: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 6: return { 'background-color': '#5FC3E1    ', 'color': '#ffffff' };
      case 7: return { 'background-color': '#5FC3E1   ', 'color': '#ffffff' };
      default: return { 'background-color': '#221e1e', 'color': '#ffffff' };
    }
  }

  get iconEstado() {
    return this.cvfData?.estado.id === 6 ? 'check_circle' : 'warning_amber';
  }
  constructor(
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject('environment') private environment: any,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackbarSrv: SnackbarService,
    private dialog: MatDialog,
    private cvfService: CvfControllerService,
    private cvfCodLerOperacionService: CvfCodLerOperacionControllerService,
    private cvfMaterialesCodLerService: CvfMaterialesCodLerControllerService,
    private codigosLerMaterialService: CodigosLerMaterialControllerService,
    private cvfMermasService: CvfMermasControllerService,
    private cvfOperacionDestinoFinalService: CvfOperacionDestinoFinalControllerService,
    private datePipe: DatePipe,
    private downloadService: DownloadService,
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.isEditable = navigation.extras.state['isEditable'] === true;
    } else if (history.state && history.state.isEditable !== undefined) {
      this.isEditable = history.state.isEditable === true;
    }
    this.cvfMaterialesCodLerService.create6
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params['id'];
    });
  }

  ngOnInit(): void {
    const state: any = history.state;
    if (state && state.searchForm) {
      this.searchFormState = state.searchForm;
      console.log('[HoldersCvfDetail ngOnInit] Capturado searchFormState:', this.searchFormState);
    }
    this.cargarDatosDesplegable();

    if (this.id) {
      this.cargarDatosCvf();
    }
  }

  
  
  cargarDatosDesplegable() {
    let filter: any = {};
    this.cvfOperacionDestinoFinalService.findAll16(filter, { page: 0, size: 1000, sort: ['codigo'] }).subscribe(
      (data: any) => {
        if (data && data.content) {
          this.operacionesDestinoFinal = data.content;
        } else if (data && data.datos) {
          this.operacionesDestinoFinal = data.datos;
        } else if (Array.isArray(data)) {
          this.operacionesDestinoFinal = data;
        } else {
          this.operacionesDestinoFinal = [];
        }
      },
      (error: any) => {
        console.error('Error al cargar datos desplegable', error);
      }
    );
  }

  cargarDatosCvf(): void {
    this.spinnerSrv.loadingShow();
    let filterCvfCodLer: any = {
      cvf: {
        id: this.id
      }
    };

    zip(
      this.cvfService.getById5(this.id),
      this.cvfCodLerOperacionService.findAll15(filterCvfCodLer, { page: 0, size: 1000 })
    ).subscribe({
      next: (responses) => {
        this.cvfData = responses[0];

        if (this.cvfData) {
          this.fechaFinCvf = this.datePipe.transform(this.cvfData.fechaFinalizacionCvf, 'dd/MM/yyyy');
          if (!this.isCvfPendiente()) {
            this.confirmacionFinal = true;
          }
          if (this.isCvfPoseedor() && (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios())) {
            this.ensureGestorDataStructure();
          }
        }

        this.cvfCodigosLerOperacion = responses[1];
        if (this.cvfCodigosLerOperacion && this.cvfCodigosLerOperacion.datos) {
          this.cvfData.combinaciones = this.cvfCodigosLerOperacion.datos.map((dto: any) => {
            const opCode = dto.operacionGestion?.codigo || dto.operacionGestionDTO?.codigo || '';
            const tipoOp = opCode.startsWith('D') ? 'D' : 'R';

            return {
              ...dto,
              cvfDTO: dto.cvf || dto.cvfDTO,
              codigoLerDTO: dto.codigoLer || dto.codigoLerDTO,
              operacionGestionDTO: dto.operacionGestion || dto.operacionGestionDTO,
              id: dto.id,
              codigoLer: dto.codigoLer?.tipoCodigo || dto.codigoLerDTO?.tipoCodigo,
              descripcionLer: dto.codigoLer?.descripcion || dto.codigoLerDTO?.descripcion,
              operacionGestion: opCode,
              cantidadTotal: dto.cantidad,
              tipoOperacion: tipoOp,
              materialesValorizados: [],
              mermas: [],
              expanded: false
            };
          });
        } else {
          this.cvfData.combinaciones = [];
        }

        this.inicializarCombinaciones();

        // Cargar detalles de combinaciones tipo R para validación inicial
        const combinacionesR = this.cvfData.combinaciones.filter((c: any) => c.tipoOperacion === 'R');
        
        if (combinacionesR.length > 0) {
          const tasks = combinacionesR.map((c: any) => 
            this.getCombinationDetailsObservable(c).pipe(
              tap((res) => this.processCombinationDetailsResponse(c, res))
            )
          );

          forkJoin(tasks).subscribe({ 
            next: () => this.spinnerSrv.loadingHide(),
            error: () => {
              this.spinnerSrv.loadingHide();
              // No mostramos error bloqueante, permitimos continuar aunque falten detalles,
              // el usuario podrá reintentar al expandir.
            }
          });
        } else {
          this.spinnerSrv.loadingHide();
        }
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar('Error al cargar datos del CVF', 'error');
      }
    });
  }

  inicializarCombinaciones(): void {
    if (!this.cvfData || !this.cvfData.combinaciones) {
      return;
    }

    this.cvfData.combinaciones.forEach((combinacion: any) => {
      if (combinacion.tipoOperacion === 'R') {
        if (!combinacion.materialesValorizados) {
          combinacion.materialesValorizados = [];
        } else {
          combinacion.materialesValorizados.forEach((m: any) => {
            if (!m.mermas) {
              m.mermas = { cantidad: 0, porcentaje: 0 };
            }
          });
        }

        if (!combinacion.mermas) {
          combinacion.mermas = [];
        }
      }

      if (!combinacion.mermasDestinoFinal) {
        combinacion.mermasDestinoFinal = { cantidad: 0, porcentaje: 0 };
      }

      combinacion.guardado = false;
      combinacion.expanded = false;
      combinacion.isLoaded = false;
    });

  }

  crearMaterialesDefecto(codigoLer: string): any[] {
    return [
      {
        codigoMaterial: 'MAT001',
        descripcion: 'Papel cartón',
        cantidad: 0,
        porcentaje: 0,
        reciclado: this.crearProcesoGestionVacio(),
        preparacionReutilizacion: this.crearProcesoGestionVacio(),
        valorizacionEnergetica: { cantidad: 0, porcentaje: 0 },
        mermas: { cantidad: 0, porcentaje: 0 }
      }
    ];
  }

  crearProcesoGestionVacio(): any {
    return {
      espanaCaOrigen: { cantidad: 0, porcentaje: 0 },
      espanaOtraCa: { cantidad: 0, porcentaje: 0 },
      eu: { cantidad: 0, porcentaje: 0 },
      fueraUe: { cantidad: 0, porcentaje: 0 }
    };
  }

  isSoloCantidadMaterialRelleno(combinacion: any): boolean {
    if (!combinacion || !combinacion.materialesValorizados) return false;
    let hasOtherFields = false;
    for (let mat of combinacion.materialesValorizados) {
      if (
        (mat.mermas && mat.mermas.cantidad > 0) ||
        (mat.operacionDestinoCode) ||
        (mat.operacionDestinoDesc && mat.operacionDestinoDesc.trim() !== '') ||
        (mat.reciclado?.espanaCaOrigen?.cantidad > 0) ||
        (mat.reciclado?.espanaOtraCa?.cantidad > 0) ||
        (mat.reciclado?.eu?.cantidad > 0) ||
        (mat.reciclado?.fueraUe?.cantidad > 0) ||
        (mat.mermasDestino > 0)
      ) {
        hasOtherFields = true;
        break;
      }
    }
    return !hasOtherFields;
  }

  toggleExpand(combinacion: any): void {
    const isClosingExpanded = this.combinacionEnEdicion === combinacion.id && combinacion.expanded;
    const isChangingExpanded = this.cambiosSinGuardar && this.combinacionEnEdicion !== null && this.combinacionEnEdicion !== combinacion.id;
    const combinacionAnterior = this.getCombinacionActual();
    
    const combinacionAEvaluar = isChangingExpanded ? combinacionAnterior : combinacion;

    const isPoseedorR = this.isCvfPoseedor() && combinacionAEvaluar?.tipoOperacion === 'R';
    const isPoseedorPendienteR = this.isCvfPoseedor() && this.isCvfPendiente() && combinacionAEvaluar?.tipoOperacion === 'R';

    if (this.cambiosSinGuardar && (isClosingExpanded || isChangingExpanded)) {
      let skipPopup = false;
      if (isPoseedorR) {
        skipPopup = this.isSoloCantidadMaterialRelleno(combinacionAEvaluar);
      } else if (isPoseedorPendienteR) {
        skipPopup = true; // Fallback to original behavior simply in case
      }

      if (skipPopup) {
        if (combinacionAnterior && combinacionAnterior.tipoOperacion === 'R') {
           this.cargarDatosDetalleCombinacion(combinacionAnterior);
        } else {
           this.restaurarCombinacion(this.combinacionEnEdicion);
        }
        this.cambiosSinGuardar = false;
        this.combinacionEnEdicion = null;
        this.expandirCombinacion(combinacion);
      } else {
        Swal.fire({
        title: 'Información no guardada',
        text: '¿Desea continuar sin guardar los cambios realizados?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'No, volver a guardar'
      }).then((result) => {
        if (result.isConfirmed) {
          if (combinacionAnterior && combinacionAnterior.tipoOperacion === 'R') {
             this.cargarDatosDetalleCombinacion(combinacionAnterior);
          } else {
             this.restaurarCombinacion(this.combinacionEnEdicion);
          }
          
          this.cambiosSinGuardar = false;
          this.combinacionEnEdicion = null;
          this.expandirCombinacion(combinacion);
        }
      });
      }
    } else {
      if (this.combinacionEnEdicion === combinacion.id && combinacion.expanded) {
         this.combinacionOriginal = null;
         
         if (combinacion.tipoOperacion === 'R') {
             this.cargarDatosDetalleCombinacion(combinacion);
         }
      }
      this.expandirCombinacion(combinacion);
    }
  }

  expandirCombinacion(combinacion: any): void {
    this.cvfData.combinaciones.forEach((c: any) => {
      if (c.id !== combinacion.id) {
         c.expanded = false;
      }
    });

    combinacion.expanded = !combinacion.expanded;
    if (combinacion.expanded) {
      this.combinacionEnEdicion = combinacion.id;
      this.hacerBackupCombinacion(combinacion);
      
      this.cargarDatosDetalleCombinacion(combinacion);
    } else {
      this.combinacionEnEdicion = null;
      this.combinacionOriginal = null;
    }
  }

  hacerBackupCombinacion(combinacion: any): void {
    if (combinacion.tipoOperacion === 'D') {
      this.combinacionOriginal = {
        operacionGestionDestino: combinacion.operacionGestionDestino
      };
    } else {
      this.combinacionOriginal = null;
    }
  }

  restaurarCombinacion(idCombinacion: number | null): void {
    if (!idCombinacion) return;
    const combinacion = this.cvfData.combinaciones.find((c: any) => c.id === idCombinacion);

    if (combinacion && this.combinacionOriginal && combinacion.tipoOperacion === 'D') {
       combinacion.operacionGestionDestino = this.combinacionOriginal.operacionGestionDestino;
    }
    this.combinacionOriginal = null;
  }

  getCombinationDetailsObservable(combinacion: any): Observable<any[]> {
    const filterMateriales: any = {
      cvfCodLerOperacion: {
        id: combinacion.id
      }
    };

    const filterMermas: any = {
      cvfCodLerOperacion: {
        id: combinacion.id
      }
    };

    // Filtro para obtener configuración por defecto del LER
    const filterLerMaterial: any = {
      codigoLer: {
        id: combinacion.codigoLerDTO ? combinacion.codigoLerDTO.id : (combinacion.codigoLer ? combinacion.codigoLer.id : null)
      }
    };

    return zip(
      this.cvfMaterialesCodLerService.findAll16(filterMateriales, { page: 0, size: 1000, sort: ['id,asc'] }),
      this.cvfMermasService.findAll15(filterMermas, { page: 0, size: 1000, sort: ['id,asc'] }),
      this.codigosLerMaterialService.findAll18(filterLerMaterial, { page: 0, size: 1000, sort: ['id,asc'] }),
    );
  }

  processCombinationDetailsResponse(combinacion: any, responses: any[]): void {
    // Identificar materiales por defecto
    const materialesPorDefectoIds: number[] = [];
    const materialesPorDefectoObjs: any[] = [];

    if (responses[2] && responses[2].datos) {
      responses[2].datos.forEach((m: any) => {
        if (m.porDefecto && m.agrupacionMaterial) {
          materialesPorDefectoIds.push(m.agrupacionMaterial.id);
          materialesPorDefectoObjs.push(m.agrupacionMaterial);
        }
      });
    }

    combinacion.materialesPorDefectoIds = materialesPorDefectoIds;

    let datosMateriales = [];
    if (responses[0]) {
      if (responses[0].datos) {
        datosMateriales = responses[0].datos;
      } else if (Array.isArray(responses[0])) {
        datosMateriales = responses[0];
      } else if (responses[0].content) {
        datosMateriales = responses[0].content;
      }
    }

    if (datosMateriales.length > 0) {
      combinacion.materialesValorizados = datosMateriales.map((dto: any, index: number) => {

        const agrupId = dto.agrupacionMaterial?.id || dto.material?.id;
        // Si el material está marcado como porDefecto = true en la configuración del LER, NO es borrable.
        // Si NO está en la lista de porDefecto (o porDefecto = false), SÍ es borrable.
        const esBorrable = !materialesPorDefectoIds.includes(agrupId);

        let cantidadAsignada = dto.cantidadTotal || 0;
        if (this.isCvfPoseedor() && !this.canViewResource('PO-ENV-GEST') && datosMateriales.length === 1 && (!dto.cantidadTotal || dto.cantidadTotal === 0)) {
          cantidadAsignada = combinacion.cantidadTotal;
          this.cambiosSinGuardar = true;
        }

        let materialResolv: any = {
          id: dto.id,
          agrupacionMaterialId: agrupId,
          codigoMaterial: dto.agrupacionMaterial?.codigo || dto.material?.codigo || dto.codigoMaterial,
          descripcion: dto.agrupacionMaterial?.descripcion || dto.material?.descripcion || dto.descripcionMaterial,
          esBorrable: esBorrable,
          cantidad: cantidadAsignada,
        };

        if (this.isCvfPoseedor()) {
          materialResolv.creadoPor = dto.creadoPor;
          materialResolv.fechaAlta = dto.fechaAlta;
          materialResolv.fechaModificacion = dto.fechaModificacion;
          materialResolv.modificadoPor = dto.modificadoPor;
          materialResolv.mermas = { cantidad: dto.mermasInstalacionesGestCant || dto.mermasInstalacionesGestorCant || 0, porcentaje: 0 };
          materialResolv.mermasDestino = dto.mermasCant || 0;
          
          // Buscar objeto de la operación destino final
          let opObj = null;
          if (dto.cvfOpDestinoFinal && this.operacionesDestinoFinal) {
             const op = this.operacionesDestinoFinal.find(x => x.codigo === dto.cvfOpDestinoFinal || x.id === dto.cvfOpDestinoFinal || 
                          (typeof dto.cvfOpDestinoFinal === 'object' && x.id === dto.cvfOpDestinoFinal.id));
             if (op) opObj = op;
             else if (typeof dto.cvfOpDestinoFinal === 'object') opObj = dto.cvfOpDestinoFinal;
          }
          materialResolv.operacionDestinoCode = opObj;
          materialResolv.operacionDestinoDesc = dto.valorOperacionDestinoFinal;

          materialResolv.reciclado = {
            espanaCaOrigen: { cantidad: dto.valorizacionEspCantCaOrigen || 0, porcentaje: 0 },
            espanaOtraCa: { cantidad: dto.valorizacionEspCantOtraCa || 0, porcentaje: 0 },
            eu: { cantidad: dto.valorizacionEuCant || 0, porcentaje: 0 },
            fueraUe: { cantidad: dto.valorizacionNoEuCant || 0, porcentaje: 0 }
          };
          
          // Inicializar estructuras vacías para evitar errores
          materialResolv.preparacionReutilizacion = this.crearProcesoGestionVacio();
          materialResolv.valorizacionEnergetica = { cantidad: 0, porcentaje: 0 };
        } else {
          materialResolv.porcentaje = combinacion.cantidadTotal ? ((dto.cantidadTotal || 0) / combinacion.cantidadTotal * 100) : 0;
          materialResolv.reciclado = {
            espanaCaOrigen: { cantidad: dto.recicladoEspCantCaOrigen || 0, porcentaje: dto.recicladoEspPorcCaOrigen || 0 },
            espanaOtraCa: { cantidad: dto.recicladoEspCantOtraCa || 0, porcentaje: dto.recicladoEspPorcOtraCa || 0 },
            eu: { cantidad: dto.recicladoEuCant || 0, porcentaje: dto.recicladoEuPorc || 0 },
            fueraUe: { cantidad: dto.recicladoNoEuCant || 0, porcentaje: dto.recicladoNoEuPorc || 0 }
          };
          materialResolv.preparacionReutilizacion = {
            espanaCaOrigen: { cantidad: dto.reutilizacionEspCantCaOrigen || 0, porcentaje: dto.reutilizacionEspPorcCaOrigen || 0 },
            espanaOtraCa: { cantidad: dto.reutilizacionEspCantOtraCa || 0, porcentaje: dto.reutilizacionEspPorcOtraCa || 0 },
            eu: { cantidad: dto.reutilizacionEuCant || 0, porcentaje: dto.reutilizacionEuPorc || 0 },
            fueraUe: { cantidad: dto.reutilizacionNoEuCant || 0, porcentaje: dto.reutilizacionNoEuPorc || 0 }
          };
          materialResolv.valorizacionEnergetica = { cantidad: dto.valorizacionCant || 0, porcentaje: dto.valorizacionPorc || 0 };
          materialResolv.mermas = { cantidad: dto.mermasCant || 0, porcentaje: dto.mermasPorc || 0 };
        }

        return materialResolv;
      });
    } else {
      combinacion.materialesValorizados = [];
    }

    if (responses[1] && responses[1].datos) {
      combinacion.mermas = responses[1].datos.map((dto: any) => ({
        id: dto.id,
        cantidad: dto.cantidadMerma || 0,
        porcentaje: combinacion.cantidadTotal ? ((dto.cantidadMerma || 0) / combinacion.cantidadTotal * 100) : 0,
        operacionGestion: dto.operacionGestion || dto.operacionGestionDTO,
        descripcion: dto.operacionGestion?.descripcion || dto.operacionGestionDTO?.descripcion
      }));
    } else {
      combinacion.mermas = [];
    }

    combinacion.isLoaded = true;
  }

  cargarDatosDetalleCombinacion(combinacion: any): void {
    this.spinnerSrv.loadingShow();

    this.getCombinationDetailsObservable(combinacion).subscribe({
      next: (responses) => {
        this.spinnerSrv.loadingHide();
        this.processCombinationDetailsResponse(combinacion, responses);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar('Error al cargar detalles de la combinación', 'error');
      }
    });
  }

  onInputChange(): void {
    this.cambiosSinGuardar = true;
  }
  
  onDatosGestorChange(): void {
    this.datosGestorModificados = true;
  }
  
  onOperacionDestinoChange(material: any, event: any): void {
      if (!this.isTipoD(material)) {
         material.operacionDestinoDesc = '';
      }
      this.onInputChange();
  }

  isTipoD(material: any): boolean {
    if (!material.operacionDestinoCode) return false;
    let op = material.operacionDestinoCode;
    // Si la operación todavía es ID (por carga antigua o fallidos), intentar buscar en lista
    if (typeof op !== 'object' && this.operacionesDestinoFinal) {
        op = this.operacionesDestinoFinal.find(x => x.id === op);
    }
    return op && op.codigo && op.codigo.startsWith('D');
  }

  isDestinoFinalReadOnly(): boolean {
    const readonlyStates = [2, 5, 6, 7];
    return readonlyStates.includes(this.cvfData?.estado?.id);
  }

  getOperacionDestinoDisplay(material: any): string {
    if (!material.operacionDestinoCode) return '';
    let op = material.operacionDestinoCode;
    if (typeof op !== 'object' && this.operacionesDestinoFinal) {
        op = this.operacionesDestinoFinal.find(x => x.id === op);
    }
    return op ? op.descripcion : '';
  }

  onCantidadMaterialPoseedorChange(material: any, event: any): void {
    if (event && event.target) {
      const val = (event.target as HTMLInputElement).value;
      material.cantidad = this.parseFormattedNumber(val);
      this.onInputChange();
    }
  }

  onCantidadMermasDestinoChange(material: any, event: any): void {
    if (event && event.target) {
      const val = (event.target as HTMLInputElement).value;
      material.mermasDestino = this.parseFormattedNumber(val);
      this.onInputChange();
    }
  }

  onCantidadTipoDChange(combinacion: any, event: any): void {
    if (!event.target.value) {
      event.target.value = '0,0000';
    }
    const cantidad = this.parseFormattedNumber(event.target.value);
    combinacion.cantidadTotal = cantidad;
    this.onInputChange();
  }

  onCantidadTotalChange(material: any, event: any): void {
    let nuevaCantidadTotal = this.parseFormattedNumber(event.target.value);

    nuevaCantidadTotal = Math.round(nuevaCantidadTotal * 100000) / 100000;

    material.cantidad = nuevaCantidadTotal;

    this.recalcularCantidadesDesdePorcentajes(material);

    const combinacion = this.getCombinacionActual();
    if (combinacion) {
      this.actualizarPorcentajesGlobales(combinacion);
    }

    this.onInputChange();
  }

  actualizarPorcentajesGlobales(combinacion: any): void {
    const totalGlobal = combinacion.cantidadTotal || 0;

    if (totalGlobal > 0) {
      combinacion.materialesValorizados?.forEach((m: any) => {
        m.porcentaje = (m.cantidad / totalGlobal) * 100;
      });
      combinacion.mermas?.forEach((m: any) => {
        m.porcentaje = (m.cantidad / totalGlobal) * 100;
      });
    } else {
      combinacion.materialesValorizados?.forEach((m: any) => m.porcentaje = 0);
      combinacion.mermas?.forEach((m: any) => m.porcentaje = 0);
    }
  }

  resetearDesgloseMaterial(material: any): void {
    material.reciclado.espanaCaOrigen.cantidad = 0; material.reciclado.espanaCaOrigen.porcentaje = 0;
    material.reciclado.espanaOtraCa.cantidad = 0; material.reciclado.espanaOtraCa.porcentaje = 0;
    material.reciclado.eu.cantidad = 0; material.reciclado.eu.porcentaje = 0;
    material.reciclado.fueraUe.cantidad = 0; material.reciclado.fueraUe.porcentaje = 0;

    material.preparacionReutilizacion.espanaCaOrigen.cantidad = 0; material.preparacionReutilizacion.espanaCaOrigen.porcentaje = 0;
    material.preparacionReutilizacion.espanaOtraCa.cantidad = 0; material.preparacionReutilizacion.espanaOtraCa.porcentaje = 0;
    material.preparacionReutilizacion.eu.cantidad = 0; material.preparacionReutilizacion.eu.porcentaje = 0;
    material.preparacionReutilizacion.fueraUe.cantidad = 0; material.preparacionReutilizacion.fueraUe.porcentaje = 0;

    material.valorizacionEnergetica.cantidad = 0; material.valorizacionEnergetica.porcentaje = 0;
    if (material.mermas) { material.mermas.cantidad = 0; material.mermas.porcentaje = 0; }
  }

  recalcularCantidadesDesdePorcentajes(material: any): void {
    const total = material.cantidad;

    material.reciclado.espanaCaOrigen.cantidad = this.calcularCantidad(material.reciclado.espanaCaOrigen.porcentaje, total);
    material.reciclado.espanaOtraCa.cantidad = this.calcularCantidad(material.reciclado.espanaOtraCa.porcentaje, total);
    material.reciclado.eu.cantidad = this.calcularCantidad(material.reciclado.eu.porcentaje, total);
    material.reciclado.fueraUe.cantidad = this.calcularCantidad(material.reciclado.fueraUe.porcentaje, total);

    material.preparacionReutilizacion.espanaCaOrigen.cantidad = this.calcularCantidad(material.preparacionReutilizacion.espanaCaOrigen.porcentaje, total);
    material.preparacionReutilizacion.espanaOtraCa.cantidad = this.calcularCantidad(material.preparacionReutilizacion.espanaOtraCa.porcentaje, total);
    material.preparacionReutilizacion.eu.cantidad = this.calcularCantidad(material.preparacionReutilizacion.eu.porcentaje, total);
    material.preparacionReutilizacion.fueraUe.cantidad = this.calcularCantidad(material.preparacionReutilizacion.fueraUe.porcentaje, total);

    material.valorizacionEnergetica.cantidad = this.calcularCantidad(material.valorizacionEnergetica.porcentaje, total);
    if (material.mermas) {
      material.mermas.cantidad = this.calcularCantidad(material.mermas.porcentaje, total);
    }
  }

  calcularPorcentaje(cantidad: number, total: number): number {
    if (total === 0) return 0;
    return (cantidad / total) * 100;
  }

  calcularCantidad(porcentaje: number, total: number): number {
    const cantidad = (porcentaje / 100) * total;
    return Math.round(cantidad * 100000) / 100000;
  }

  onCantidadChange(material: any, campo: string, subCampo: string, event: any): void {
    let cantidad = this.parseFormattedNumber(event.target.value);

    cantidad = Math.round(cantidad * 100000) / 100000;

    this.setNestedValue(material, campo, subCampo, 'cantidad', cantidad);

    // Solo recalculamos distribución exacta si ya hemos cubierto el total (restante ~ 0)
    // De lo contrario, cálculo simple del porcentaje correspondiente a esta fila.
    const restante = Math.abs(this.calcularCantidadRestante(material));
    if (restante < 0.00001) {
      this.recalcularPorcentajesDesglose(material);
    } else {
      let nuevoPorcentaje = 0;
      if (material.cantidad && material.cantidad !== 0) {
        nuevoPorcentaje = (cantidad / material.cantidad) * 100;
        nuevoPorcentaje = Math.round(nuevoPorcentaje * 100) / 100;
      }
      this.setNestedValue(material, campo, subCampo, 'porcentaje', nuevoPorcentaje);
    }

    this.onInputChange();
  }

  recalcularPorcentajesDesglose(material: any): void {
    if (!material) return;

    const items = [
      material.reciclado?.espanaCaOrigen,
      material.reciclado?.espanaOtraCa,
      material.reciclado?.eu,
      material.reciclado?.fueraUe,
      material.preparacionReutilizacion?.espanaCaOrigen,
      material.preparacionReutilizacion?.espanaOtraCa,
      material.preparacionReutilizacion?.eu,
      material.preparacionReutilizacion?.fueraUe,
      material.valorizacionEnergetica,
      material.mermas
    ].filter(i => !!i);

    this.distribuirPorcentajesExactos(material.cantidad, items);
  }

  distribuirPorcentajesExactos(total: number, items: any[]): void {
    if (!total || total === 0) {
      items.forEach(i => i.porcentaje = 0);
      return;
    }

    const factor = 100;

    const sumQuantities = items.reduce((acc, curr) => acc + (curr.cantidad || 0), 0);

    let totalTargetPctInt = Math.round((sumQuantities / total) * 100 * factor);
    if (Math.abs(sumQuantities - total) < 0.00001) {
      totalTargetPctInt = 100 * factor;
    }

    let currentSumInt = 0;

    let maxItemIndex = -1;
    let maxVal = -1;

    items.forEach((item, index) => {
      const qty = item.cantidad || 0;

      if (qty === 0) {
        item.porcentaje = 0;
        return;
      }

      const pctInt = Math.round((qty / total) * 100 * factor);

      item._tempPctInt = pctInt;
      currentSumInt += pctInt;

      if (Math.abs(qty) > maxVal) {
        maxVal = Math.abs(qty);
        maxItemIndex = index;
      }
    });

    const diffInt = totalTargetPctInt - currentSumInt;

    if (diffInt !== 0 && maxItemIndex !== -1) {
      items[maxItemIndex]._tempPctInt += diffInt;
    }

    items.forEach(item => {
      if (item._tempPctInt !== undefined) {
        item.porcentaje = item._tempPctInt / factor;
        delete item._tempPctInt;
      }
    });
  }

  onPorcentajeChange(material: any, campo: string, subCampo: string, event: any): void {
    const porcentaje = this.parseFormattedNumber(event.target.value);

    this.setNestedValue(material, campo, subCampo, 'porcentaje', porcentaje);

    // Solo recalculamos distribución exacta de cantidades si el porcentaje suma 100% (restante ~ 0)
    // De lo contrario, cálculo simple de la cantidad correspondiente a esta fila.
    const restante = Math.abs(this.calcularPorcentajeRestante(material));
    if (restante < 0.01) {
      this.recalcularDesgloseMaterial(material);
    } else {
      let nuevaCantidad = 0;
      if (material.cantidad) {
        nuevaCantidad = this.calcularCantidad(porcentaje, material.cantidad);
      }
      this.setNestedValue(material, campo, subCampo, 'cantidad', nuevaCantidad);
    }

    this.onInputChange();
  }

  recalcularDesgloseMaterial(material: any): void {
    if (!material) return;

    const items = [
      material.reciclado?.espanaCaOrigen,
      material.reciclado?.espanaOtraCa,
      material.reciclado?.eu,
      material.reciclado?.fueraUe,
      material.preparacionReutilizacion?.espanaCaOrigen,
      material.preparacionReutilizacion?.espanaOtraCa,
      material.preparacionReutilizacion?.eu,
      material.preparacionReutilizacion?.fueraUe,
      material.valorizacionEnergetica,
      material.mermas
    ].filter(i => !!i);

    this.distribuirCantidadesExactas(material.cantidad, items);
  }

  distribuirCantidadesExactas(total: number, items: any[]): void {
    const factor = 100000;
    const totalInt = Math.round(total * factor);

    let currentSumInt = 0;

    let maxItemIndex = -1;
    let maxVal = -1;

    items.forEach((item, index) => {
      const pct = item.porcentaje || 0;

      if (pct === 0) {
        item.cantidad = 0;
        return;
      }

      const cantidadInt = Math.round((totalInt * pct) / 100);

      item._tempCantidadInt = cantidadInt;
      currentSumInt += cantidadInt;

      if (Math.abs(cantidadInt) > maxVal) {
        maxVal = Math.abs(cantidadInt);
        maxItemIndex = index;
      }
    });

    const diffInt = totalInt - currentSumInt;

    if (diffInt !== 0 && maxItemIndex !== -1) {
      items[maxItemIndex]._tempCantidadInt += diffInt;
    }
    items.forEach(item => {
      if (item._tempCantidadInt !== undefined) {
        item.cantidad = item._tempCantidadInt / factor;
        delete item._tempCantidadInt;
      }
    });
  }

  setNestedValue(obj: any, campo1: string, campo2: string, propiedad: string, valor: any): void {
    if (!obj[campo1]) {
      obj[campo1] = {};
    }

    if (campo2 && campo2.trim() !== '') {
      if (!obj[campo1][campo2]) {
        obj[campo1][campo2] = {};
      }
      obj[campo1][campo2][propiedad] = valor;
    } else {
      obj[campo1][propiedad] = valor;
    }
  }

  getNestedValue(obj: any, campo1: string, campo2: string, propiedad: string): any {
    if (campo2 && campo2.trim() !== '') {
      return obj[campo1]?.[campo2]?.[propiedad] || 0;
    } else {
      return obj[campo1]?.[propiedad] || 0;
    }
  }

  getCombinacionActual(): any | undefined {
    return this.cvfData.combinaciones.find((c: any) => c.id === this.combinacionEnEdicion);
  }

  parseFormattedNumber(value: any): number {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    const clean = value.toString().replace(/\./g, '').replace(',', '.');
    return parseFloat(clean) || 0;
  }

  onAddMaterial(combinacion: any): void {
    const cantidadRestante = this.calcularCantidadRestanteGlobal(combinacion);
    const porcentajeRestante = this.calcularPorcentajeRestanteGlobal(combinacion);

    if (Math.abs(cantidadRestante) < 0.00001 && Math.abs(porcentajeRestante) < 0.01) {
      const totalGestionado = combinacion?.cantidadTotal || 0;
      const formattedTotal = Math.round(totalGestionado * 100000) / 100000;
      Swal.fire({
        text: `Ya ha reportado la información de los ${formattedTotal} (t) gestionados. Si necesita informar de otros materiales o mermas en las propias instalaciones, ajuste sus datos.`,
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
      return;
    }    
    
    const usedMaterialIds = combinacion.materialesValorizados?.map((m: any) => m.agrupacionMaterialId) || [];

    const dialogRef = this.dialog.open(HoldersCvfMaterialDialogComponent, {
      width: '500px',
      data: {
        materialesDisponibles: [],
        materialesUsados: [],
        materialesUsadosIds: usedMaterialIds,
        combinacionId: combinacion.id,
        codigoLerId: combinacion.codigoLerDTO?.id || combinacion.codigoLer?.id
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const newMaterial: any = {
          id: result.id,
          agrupacionMaterialId: result.agrupacionMaterial?.id,
          codigoMaterial: result.agrupacionMaterial?.codigo,
          descripcion: result.agrupacionMaterial?.descripcion,
          esBorrable: true,
          cantidad: 0,
          porcentaje: 0,
          reciclado: this.crearProcesoGestionVacio(),
          preparacionReutilizacion: this.crearProcesoGestionVacio(),
          valorizacionEnergetica: { cantidad: 0, porcentaje: 0 },
          mermas: { cantidad: 0, porcentaje: 0 }
        };

        if (!combinacion.materialesValorizados) {
          combinacion.materialesValorizados = [];
        }
        
        if (this.isCvfPoseedor() && !this.canViewResource('PO-ENV-GEST') && combinacion.materialesValorizados.length === 0) {
          newMaterial.cantidad = combinacion.cantidadTotal;
        }

        combinacion.materialesValorizados.push(newMaterial);

        if (this.combinacionEnEdicion !== combinacion.id) {
          this.combinacionEnEdicion = combinacion.id;
          combinacion.expanded = true;
        }

        this.actualizarPorcentajesGlobales(combinacion);
        this.cambiosSinGuardar = true;
      }
    });
  }

  onAddMerma(combinacion: any): void {
    const cantidadRestante = this.calcularCantidadRestanteGlobal(combinacion);
    const porcentajeRestante = this.calcularPorcentajeRestanteGlobal(combinacion);

    if (Math.abs(cantidadRestante) < 0.00001 && Math.abs(porcentajeRestante) < 0.01) {
      const totalGestionado = combinacion?.cantidadTotal || 0;
      const formattedTotal = Math.round(totalGestionado * 100000) / 100000;
      Swal.fire({
        text: `Ya ha reportado la información de los ${formattedTotal} (t) gestionados. Si necesita informar de otros materiales o mermas en las propias instalaciones, ajuste sus datos.`,
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    const dialogRef = this.dialog.open(HoldersCvfMaterialDialogComponent, {
      width: '500px',
      data: {
        materialesDisponibles: [],
        materialesUsados: [],
        isMerma: true,
        combinacionId: combinacion.id
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {

        if (!combinacion.mermas) {
          combinacion.mermas = [];
        }

        const newMerma = {
          id: result.id,
          cantidad: result.cantidadMerma || 0,
          porcentaje: 0,
          operacionGestion: result.operacionGestion || result.operacionGestionDTO,
          descripcion: result.operacionGestion?.descripcion || result.operacionGestionDTO?.descripcion
        };

        combinacion.mermas.push(newMerma);

        if (this.combinacionEnEdicion !== combinacion.id) {
          this.combinacionEnEdicion = combinacion.id;
          combinacion.expanded = true;
        }

        this.actualizarPorcentajesGlobales(combinacion);
        this.cambiosSinGuardar = true;
      }
    });
  }

  onMermaCantidadChange(merma: any, combinacion: any, event: any): void {
    let cantidad = this.parseFormattedNumber(event.target.value);

    cantidad = Math.round(cantidad * 100000) / 100000;

    if (!merma) return;

    merma.cantidad = cantidad;
    this.actualizarPorcentajesGlobales(combinacion);

    this.onInputChange();
  }

  onPorcentajeTotalChange(material: any, event: any): void {
    const nuevoPorcentaje = this.parseFormattedNumber(event.target.value);
    const combinacion = this.getCombinacionActual();

    if (!combinacion) return;

    if (nuevoPorcentaje < 0) return;

    const totalGlobal = combinacion.cantidadTotal || 0;

    let nuevaCantidad = (nuevoPorcentaje * totalGlobal) / 100;
    nuevaCantidad = Math.round(nuevaCantidad * 100000) / 100000;

    material.cantidad = nuevaCantidad;

    this.recalcularCantidadesDesdePorcentajes(material);

    this.actualizarPorcentajesGlobales(combinacion);

    this.onInputChange();
  }

  onMermaPorcentajeChange(merma: any, combinacion: any, event: any): void {
    const nuevoPorcentaje = this.parseFormattedNumber(event.target.value);

    if (!merma) return;
    if (nuevoPorcentaje < 0) return;

    const totalGlobal = combinacion.cantidadTotal || 0;

    let nuevaCantidad = (nuevoPorcentaje * totalGlobal) / 100;
    nuevaCantidad = Math.round(nuevaCantidad * 100000) / 100000;
    merma.porcentaje = nuevoPorcentaje;
    merma.cantidad = nuevaCantidad;

    this.actualizarPorcentajesGlobales(combinacion);
    this.onInputChange();
  }

  anadirMaterial(combinacion: any): void {
    if (!combinacion.materialesValorizados) {
      combinacion.materialesValorizados = [];
    }

    let nuevaCantidad = 0;
    if (this.isCvfPoseedor() && !this.canViewResource('PO-ENV-GEST') && combinacion.materialesValorizados.length === 0) {
      nuevaCantidad = combinacion.cantidadTotal;
      this.cambiosSinGuardar = true;
    }

    combinacion.materialesValorizados.push({
      codigoMaterial: '',
      descripcion: '',
      esBorrable: true,
      cantidad: nuevaCantidad,
      porcentaje: 0,
      reciclado: this.crearProcesoGestionVacio(),
      preparacionReutilizacion: this.crearProcesoGestionVacio(),
      valorizacionEnergetica: { cantidad: 0, porcentaje: 0 },
      mermas: { cantidad: 0, porcentaje: 0 }
    });

    this.onInputChange();
  }

  eliminarMaterial(combinacion: any, index: number): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Se eliminará este material de la lista',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const material = combinacion.materialesValorizados[index];
        if (material.id) {
          this.spinnerSrv.loadingShow();
          this.cvfMaterialesCodLerService.deleteById6(material.id).subscribe({
            next: () => {
              this.spinnerSrv.loadingHide();
              combinacion.materialesValorizados?.splice(index, 1);
              if (this.isCvfPoseedor() && !this.canViewResource('PO-ENV-GEST') && combinacion.materialesValorizados?.length === 1) {
                combinacion.materialesValorizados[0].cantidad = combinacion.cantidadTotal;
              }
              this.actualizarPorcentajesGlobales(combinacion);
              this.onInputChange();
              this.snackbarSrv.showSnackBar('Material eliminado correctamente', 'success');
            },
            error: () => {
              this.spinnerSrv.loadingHide();
              this.snackbarSrv.showSnackBar('Error al eliminar el material', 'error');
            }
          });
        } else {
          combinacion.materialesValorizados?.splice(index, 1);
          if (this.isCvfPoseedor() && !this.canViewResource('PO-ENV-GEST') && combinacion.materialesValorizados?.length === 1) {
            combinacion.materialesValorizados[0].cantidad = combinacion.cantidadTotal;
          }
          this.actualizarPorcentajesGlobales(combinacion);
          this.onInputChange();
        }
      }
    });
  }

  anadirMerma(combinacion: any): void {
    if (!combinacion.mermas) {
      combinacion.mermas = [];
    }

    combinacion.mermas.push({
      codigoMaterial: '',
      descripcion: '',
      operacionGestion: '',
      cantidad: 0,
      porcentaje: 0
    });

    this.onInputChange();
  }

  eliminarMerma(combinacion: any, index: number): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Se eliminará esta merma de la lista',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const merma = combinacion.mermas[index];
        if (merma.id) {
          this.spinnerSrv.loadingShow();
          this.cvfMermasService.deleteById5(merma.id).subscribe({
            next: () => {
              this.spinnerSrv.loadingHide();
              combinacion.mermas?.splice(index, 1);
              this.actualizarPorcentajesGlobales(combinacion);
              this.onInputChange();
              this.snackbarSrv.showSnackBar('Merma eliminada correctamente', 'success');
            },
            error: () => {
              this.spinnerSrv.loadingHide();
              this.snackbarSrv.showSnackBar('Error al eliminar la merma', 'error');
            }
          });
        } else {
          combinacion.mermas?.splice(index, 1);
          this.actualizarPorcentajesGlobales(combinacion);
          this.onInputChange();
        }
      }
    });
  }

  guardarCombinacion(combinacion: any): void {
    this.spinnerSrv.loadingShow();

    if (combinacion.tipoOperacion === 'D') {
      if (!combinacion.operacionGestionDestino || combinacion.operacionGestionDestino.toString().trim() === '') {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar('El campo Operación de Gestión en Destino Final es obligatorio', 'error');
        return;
      }

      const dto: any = {
        id: combinacion.id,
        cvf: { id: combinacion.cvfDTO?.id || this.cvfData?.id },
        codigoLer: { id: combinacion.codigoLerDTO?.id },
        operacionGestion: { id: combinacion.operacionGestionDTO?.id },
        cantidad: combinacion.cantidadTotal,
        operacionGestionDestino: combinacion.operacionGestionDestino
      };

      this.cvfCodLerOperacionService.editById8(combinacion.id, dto).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar('Guardado correctamente', 'success');
          this.cambiosSinGuardar = false;
          this.hacerBackupCombinacion(combinacion);
          
          combinacion.expanded = false;
          this.combinacionEnEdicion = null;
        },
        error: (err: any) => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar('Error al guardar operación D', 'error');
        }
      });

    } else if (combinacion.tipoOperacion === 'R') {

      const validacion = this.validarCombinacionTipoR(combinacion);
      if (!validacion.valido) {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar(validacion.error || 'Error de validación', 'error');
        return;
      }

      const materialsToLink: any[] = combinacion.materialesValorizados || [];
      if (materialsToLink.length === 0) {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar('No hay materiales para guardar', 'info');
        return;
      }

      const observables: Observable<any>[] = materialsToLink.map((material: any) => {
        let dto: any;

        if (this.isCvfPoseedor()) {
          dto = {
            id: material.id,
            agrupacionMaterial: material.agrupacionMaterialId,
            cantidadTotal: material.cantidad,
            creadoPor: material.creadoPor,
            cvfCodLerOperacion: combinacion.id,
            cvfOpDestinoFinal: material.operacionDestinoCode,
            fechaAlta: material.fechaAlta,
            fechaModificacion: material.fechaModificacion,
            mermasCant: material.mermasDestino ? Math.round(material.mermasDestino * 100000) / 100000 : 0,
            mermasInstalacionesGestorCant: material.mermas?.cantidad ? Math.round(material.mermas.cantidad * 100000) / 100000 : 0,
            modificadoPor: material.modificadoPor,
            valorOperacionDestinoFinal: material.operacionDestinoDesc,
            valorizacionEspCantCaOrigen: material.reciclado?.espanaCaOrigen?.cantidad,
            valorizacionEspCantOtraCa: material.reciclado?.espanaOtraCa?.cantidad,
            valorizacionEuCant: material.reciclado?.eu?.cantidad,
            valorizacionNoEuCant: material.reciclado?.fueraUe?.cantidad
          };
        } else {
          dto = {
            id: material.id,
            cvfCodLerOperacion: combinacion.id,
            agrupacionMaterial: material.agrupacionMaterialId,

            cantidadTotal: material.cantidad,
            porcentajeTotal: material.porcentaje,

            recicladoEspCantCaOrigen: material.reciclado?.espanaCaOrigen?.cantidad,
            recicladoEspCantOtraCa: material.reciclado?.espanaOtraCa?.cantidad,
            recicladoEspPorcCaOrigen: material.reciclado?.espanaCaOrigen?.porcentaje,
            recicladoEspPorcOtraCa: material.reciclado?.espanaOtraCa?.porcentaje,
            recicladoEuCant: material.reciclado?.eu?.cantidad,
            recicladoEuPorc: material.reciclado?.eu?.porcentaje,
            recicladoNoEuCant: material.reciclado?.fueraUe?.cantidad,
            recicladoNoEuPorc: material.reciclado?.fueraUe?.porcentaje,

            reutilizacionEspCantCaOrigen: material.preparacionReutilizacion?.espanaCaOrigen?.cantidad,
            reutilizacionEspCantOtraCa: material.preparacionReutilizacion?.espanaOtraCa?.cantidad,
            reutilizacionEspPorcCaOrigen: material.preparacionReutilizacion?.espanaCaOrigen?.porcentaje,
            reutilizacionEspPorcOtraCa: material.preparacionReutilizacion?.espanaOtraCa?.porcentaje,
            reutilizacionEuCant: material.preparacionReutilizacion?.eu?.cantidad,
            reutilizacionEuPorc: material.preparacionReutilizacion?.eu?.porcentaje,
            reutilizacionNoEuCant: material.preparacionReutilizacion?.fueraUe?.cantidad,
            reutilizacionNoEuPorc: material.preparacionReutilizacion?.fueraUe?.porcentaje,

            valorizacionCant: material.valorizacionEnergetica?.cantidad,
            valorizacionPorc: material.valorizacionEnergetica?.porcentaje,

            mermasCant: material.mermas?.cantidad ? Math.round(material.mermas.cantidad * 100000) / 100000 : 0,
            mermasPorc: material.mermas?.porcentaje
          };
        }

        if (material.id) {
          return this.cvfMaterialesCodLerService.editById7(material.id, dto);
        } else {
          const request: any = {
            ...dto,
            cvfCodLerOperacion: combinacion.id,
            agrupacionMaterial: material.agrupacionMaterialId
          };
          return this.cvfMaterialesCodLerService.create6(request);
        }
      });

      forkJoin(observables).pipe(
        switchMap(() => {
          const mermasToSave = combinacion.mermas || [];
          if (mermasToSave.length === 0) {
            return of([]);
          }

          const mermaObservables = mermasToSave.map((merma: any) => {
            const opGestionId = merma.operacionGestion?.id || merma.operacionGestionDTO?.id;

            let obs$: Observable<any>;
            if (merma.id) {
              const payload: any = {
                id: merma.id,
                cvfCodLerOperacion: combinacion.id,
                operacionGestion: opGestionId,
                cantidadMerma: merma.cantidad ? Math.round(merma.cantidad * 100000) / 100000 : 0,
                porcentajeMerma: merma.porcentaje
              };
              obs$ = this.cvfMermasService.editById6(merma.id, payload);
            } else {
              const request: any = {
                payload: {
                  cvfCodLerOperacion: combinacion.id,
                  operacionGestion: opGestionId,
                  cantidadMerma: merma.cantidad ? Math.round(merma.cantidad * 100000) / 100000 : 0,
                  porcentajeMerma: merma.porcentaje
                }
              };
              obs$ = this.cvfMermasService.create5(request);
            }

            return obs$.pipe(
              tap((res: any) => {
                if (res && res.id) {
                  merma.id = res.id;
                }
              })
            );
          });
          return forkJoin(mermaObservables);
        })
      ).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar('Guardado correctamente', 'success');
          this.cambiosSinGuardar = false;

          combinacion.expanded = false;
          this.combinacionEnEdicion = null;
        },
        error: (err: any) => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar('Error al guardar', 'error');
        }
      });
    }
  }

  validarCombinacionTipoR(combinacion: any): { valido: boolean; error?: string } {
    // Validación 1: Todas las casillas cumplimentadas
    if (!combinacion.materialesValorizados || combinacion.materialesValorizados.length === 0) {
      return { valido: false, error: 'Debe añadir al menos un material valorizado' };
    }

    // Validación: Al menos un material "por defecto" debe tener cantidad > 0 (si existen materiales por defecto)
    if (combinacion.materialesPorDefectoIds && combinacion.materialesPorDefectoIds.length > 0) {
      let algunoPorDefectoRelleno = false;
      const nombresDeMaterialesPorDefecto: string[] = [];

      for (const material of combinacion.materialesValorizados) {
        if (combinacion.materialesPorDefectoIds.includes(material.agrupacionMaterialId)) {
          nombresDeMaterialesPorDefecto.push(material.descripcion || 'Conocido');
          if (material.cantidad > 0) {
            algunoPorDefectoRelleno = true;
          }
        }
      }


      if (algunoPorDefectoRelleno) {

      } else {
        const nombresUnicos = [...new Set(nombresDeMaterialesPorDefecto)].join(', ');
        const msgMateriales = nombresUnicos ? `(${nombresUnicos})` : '';

        return {
          valido: false,
          error: `Debe rellenar al menos uno de los materiales obligatorios para este LER ${msgMateriales}.`
        };
      }
    }

    // Validación 2: Cuadre de masas y porcentajes por Material (Desglose Interno)
    for (const material of combinacion.materialesValorizados) {

      if (this.isCvfPoseedor()) {
        const algunDestinoRelleno = 
          (material.reciclado?.espanaCaOrigen?.cantidad > 0) ||
          (material.reciclado?.espanaOtraCa?.cantidad > 0) ||
          (material.reciclado?.eu?.cantidad > 0) ||
          (material.reciclado?.fueraUe?.cantidad > 0);

        /**if ( !material.operacionDestinoCode) {
          return {
            valido: false,
            error: `Debe seleccionar una operación de destino final para el material: ${material.descripcion}`
          };
        }**/
        const isD = this.isTipoD(material);
        if (isD && !material.operacionDestinoDesc) {
             return {
                valido: false,
                error: `Debe indicar una descripción para la operación de destino final seleccionada en el material: ${material.descripcion}`
             };
        }
      }

      const totalDesglose = this.calcularTotalDesgloseMaterial(material);
      const diferenciaCant = Math.abs(material.cantidad - totalDesglose);

      if (diferenciaCant > 0.00001) {
        if (this.isCvfPoseedor()) {
          return {
            valido: false,
            error: `La suma de la cantidad (t) por ubicación de la instalación de gestión, de las mermas en las instalaciones del gestor(t) y de las mermas en el destino final del material ${material.descripcion}, debe coincidir con la cantidad material (t) reportada`
          };
        } else {
          return {
            valido: false,
            error: `Error desglose cantidades: El material ${material.descripcion} no cuadra. Total Material: ${material.cantidad.toFixed(5)}t, Desglose: ${totalDesglose.toFixed(5)}t`
          };
        }
      }

      if (material.cantidad > 0 && !this.isCvfPoseedor()) {
        const totalPorcDesglose = this.calcularTotalDesglosePorcentaje(material);
        const diferenciaPorc = Math.abs(100 - totalPorcDesglose);

        if (diferenciaPorc > 0.01) {
          return {
            valido: false,
            error: `Error desglose porcentajes: El material ${material.descripcion} no suma 100%. Suma actual: ${totalPorcDesglose.toFixed(2)}%`
          };
        }
      }
    }

    // Validación 3: Cuadre Global (Suma de Materiales + Mermas vs Total Operación)
    const totalMateriales = combinacion.materialesValorizados.reduce((sum: number, m: any) => sum + (m.cantidad || 0), 0);
    const totalMermas = combinacion.mermas?.reduce((sum: number, m: any) => sum + (m.cantidad || 0), 0) || 0;
    const sumaTotal = totalMateriales + totalMermas;
    const diferenciaGlobalCant = Math.abs(combinacion.cantidadTotal - sumaTotal);

    if (diferenciaGlobalCant > 0.00001) {
      return {
        valido: false,
        error: `Error global cantidades: La suma de materiales (${totalMateriales.toFixed(5)}t) y mermas (${totalMermas.toFixed(5)}t) no coincide con el total del LER (${(combinacion.cantidadTotal || 0).toFixed(5)}t)`
      };
    }

    if (combinacion.cantidadTotal > 0 && !this.isCvfPoseedor()) {
      const totalPorcMateriales = combinacion.materialesValorizados.reduce((sum: number, m: any) => sum + (m.porcentaje || 0), 0);
      const totalPorcMermas = combinacion.mermas?.reduce((sum: number, m: any) => sum + (m.porcentaje || 0), 0) || 0;
      const sumaGlobalPorc = totalPorcMateriales + totalPorcMermas;
      const diferenciaGlobalPorc = Math.abs(100 - sumaGlobalPorc);

      if (diferenciaGlobalPorc > 0.01) {
        return {
          valido: false,
          error: `Error global porcentajes: La suma de porcentajes de materiales (${totalPorcMateriales.toFixed(2)}%) y mermas (${totalPorcMermas.toFixed(2)}%) debe ser 100%. Actual: ${sumaGlobalPorc.toFixed(2)}%`
        };
      }
    }

    return { valido: true };
  }

  calcularTotalDesgloseMaterial(material: any): number {
    let total = 0;

    total += material.reciclado.espanaCaOrigen.cantidad;
    total += material.reciclado.espanaOtraCa.cantidad;
    total += material.reciclado.eu.cantidad;
    total += material.reciclado.fueraUe.cantidad;

    total += material.preparacionReutilizacion.espanaCaOrigen.cantidad;
    total += material.preparacionReutilizacion.espanaOtraCa.cantidad;
    total += material.preparacionReutilizacion.eu.cantidad;
    total += material.preparacionReutilizacion.fueraUe.cantidad;

    total += material.valorizacionEnergetica.cantidad;
    total += material.mermas?.cantidad || 0;
    
    if (this.isCvfPoseedor()) {
      total += material.mermasDestino || 0;
    }

    return total;
  }

  calcularTotalDesglosePorcentaje(material: any): number {
    let total = 0;

    total += material.reciclado.espanaCaOrigen.porcentaje;
    total += material.reciclado.espanaOtraCa.porcentaje;
    total += material.reciclado.eu.porcentaje;
    total += material.reciclado.fueraUe.porcentaje;

    total += material.preparacionReutilizacion.espanaCaOrigen.porcentaje;
    total += material.preparacionReutilizacion.espanaOtraCa.porcentaje;
    total += material.preparacionReutilizacion.eu.porcentaje;
    total += material.preparacionReutilizacion.fueraUe.porcentaje;

    total += material.valorizacionEnergetica.porcentaje;
    total += material.mermas?.porcentaje || 0;

    return total;
  }

  calcularPorcentajeRestante(material: any): number {
    const totalDesglose = this.calcularTotalDesglosePorcentaje(material);
    let restante = 100 - totalDesglose;
    return Math.round(restante * 100) / 100;
  }

  calcularCantidadRestante(material: any): number {
    const totalDesglose = this.calcularTotalDesgloseMaterial(material);
    let restante = material.cantidad - totalDesglose;
    return Math.round(restante * 100000) / 100000;
  }

  calcularPorcentajeRestanteGlobal(combinacion: any): number {
    if (!combinacion) return 100;

    let totalPorcentaje = 0;

    if (combinacion.materialesValorizados) {
      totalPorcentaje += combinacion.materialesValorizados.reduce((sum: number, m: any) => sum + (m.porcentaje || 0), 0);
    }

    if (combinacion.mermas) {
      totalPorcentaje += combinacion.mermas.reduce((sum: number, m: any) => sum + (m.porcentaje || 0), 0);
    }

    let restante = 100 - totalPorcentaje;
    return Math.round(restante * 100) / 100;
  }

  calcularCantidadRestanteGlobal(combinacion: any): number {
    if (!combinacion) return 0;

    let totalCantidad = 0;

    if (combinacion.materialesValorizados) {
      totalCantidad += combinacion.materialesValorizados.reduce((sum: number, m: any) => sum + (m.cantidad || 0), 0);
    }

    if (combinacion.mermas) {
      totalCantidad += combinacion.mermas.reduce((sum: number, m: any) => sum + (m.cantidad || 0), 0);
    }

    let restante = (combinacion.cantidadTotal || 0) - totalCantidad;
    return Math.round(restante * 100000) / 100000;
  }



  finalizarCVF(): void {
    if (!this.isEditable) {
      this.snackbarSrv.showSnackBar('No tiene permisos para finalizar', 'error');
      return;
    }

    // Validación de Checkbox
    if (!this.confirmacionFinal) {
      this.snackbarSrv.showSnackBar('Debe confirmar que los datos son correctos', 'error');
      return;
    }

    if (this.isCvfPoseedor() && (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios())) {
      const nima = this.cvfData?.nimaGestor || this.cvfData?.gestorResiduos?.nima;
      const razonSocial = this.cvfData?.gestorResiduos?.razonSocial;
      const documento = this.cvfData?.gestorResiduos?.codigoDocumento;
      const direccion = this.getDireccionFisicaGestorForEdit()?.fullAddress || this.cvfData?.direccionFisicaGestor;

      if (!nima || !razonSocial || !documento || !direccion) {
        this.snackbarSrv.showSnackBar('Debe completar los datos del gestor para finalizar', 'error');
        return;
      }
    }

    if (!this.cvfData || !this.cvfData.combinaciones) {
      return;
    }

    const combinacionesRNoCargadas = this.cvfData.combinaciones.filter(
      (c: any) => c.tipoOperacion === 'R' && !c.isLoaded
    );

    if (combinacionesRNoCargadas.length > 0) {
      this.spinnerSrv.loadingShow();
      const observables = combinacionesRNoCargadas.map((c: any) =>
        this.getCombinationDetailsObservable(c).pipe(
          tap((responses) => this.processCombinationDetailsResponse(c, responses))
        )
      );

      forkJoin(observables).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.validarYFinalizar();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackbarSrv.showSnackBar('Error al cargar datos pendientes para validación', 'error');
        }
      });
    } else {
      this.validarYFinalizar();
    }
  }

  validarYFinalizar(): void {
    // Validación de Combinaciones
    if (this.cvfData && this.cvfData.combinaciones) {
      for (const combinacion of this.cvfData.combinaciones) {

        if (combinacion.tipoOperacion === 'D') {
          // Validar campos de cantidad y operación de gestión destino no estén vacíos
          const hasCantidad = combinacion.cantidadTotal !== null && combinacion.cantidadTotal !== undefined && combinacion.cantidadTotal > 0;
          const hasDestino = combinacion.operacionGestionDestino && combinacion.operacionGestionDestino.toString().trim() !== '';

          if (!hasCantidad || !hasDestino) {
            this.snackbarSrv.showSnackBar(`La operación para el LER ${combinacion.codigoLer} no está completa.`, 'error');
            if (!combinacion.expanded) {
              this.expandirCombinacion(combinacion);
            }
            return;
          }

        } else if (combinacion.tipoOperacion === 'R') {
          // Validación unificada para Tipo R usando validarCombinacionTipoR
          const valR = this.validarCombinacionTipoR(combinacion);
          if (!valR.valido) {
            this.snackbarSrv.showSnackBar(`Error en LER ${combinacion.codigoLer}: ${valR.error}`, 'error');
            if (!combinacion.expanded) {
              this.expandirCombinacion(combinacion);
            }
            return;
          }
        }
      }
    }

    Swal.fire({
      title: '¿Guardar CVF?',
      text: this.isCvfPoseedor() ? 'El CVF pasará al estado pendiente de firma. A continuación, deberá descargarlo y remitirlo a su gestor para que proceda a su firma. Una vez firmado, deberá cargarlo de nuevo en ENVANET para poder finalizar el CVF.' : 'El CVF cambiará a estado FINALIZADO y no podrá modificarse',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerSrv.loadingShow();

        this.cvfService.guardarCvf(this.id).subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar('CVF guardado correctamente', 'success');
            this.isEditable = false;
            // Permanecer en la vista y recargar datos para reflejar estado actual
            this.cargarDatosCvf();
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar('Error al guardar el CVF', 'error');
          }
        });
      }
    });
  }

  openModalAyuda() {
    const dialogRef = this.dialog.open(
      HoldersCvfImageDetailComponent,
      {
        width: '98%',
        maxWidth: '98%',
        maxHeight: '95vh',
        disableClose: true,
        data: {
          isPoseedor: this.isCvfPoseedor()
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  navigateBack(): void {
    if (this.searchFormState) {
      sessionStorage.setItem('holdersCvfInvoicesSearchForm', JSON.stringify(this.searchFormState));
      console.log('[HoldersCvfDetail navigateBack] Guardado searchFormState en sessionStorage');
    }
    if (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) {
      localStorage.removeItem('cvfTypeFromRoute');
      this.router.navigate(['/holders/holders-cvf-search'], { state: { searchForm: this.searchFormState } });
    } else {
      if (this.isCvfPoseedor()) {
        localStorage.setItem('cvfTypeFromRoute', 'poseedor');
        this.router.navigate(['/holders/holders-cvf-search'], { state: { searchForm: this.searchFormState } });
      } else {
        localStorage.setItem('cvfTypeFromRoute', 'gestor');
        this.router.navigate(['/holders/holders-cvf-search'], { state: { searchForm: this.searchFormState } });
      }
    }
  }

  cerrar(): void {
    let skipPopup = !this.cambiosSinGuardar;

    if (this.cambiosSinGuardar) {
      const combinacion = this.getCombinacionActual();
      const isPoseedorR = this.isCvfPoseedor() && combinacion?.tipoOperacion === 'R';
      const isPoseedorPendienteR = this.isCvfPoseedor() && this.isCvfPendiente() && 
                                   this.cvfData?.combinaciones?.some((c: any) => c.tipoOperacion === 'R');

      if (isPoseedorR) {
        skipPopup = this.isSoloCantidadMaterialRelleno(combinacion);
      } else if (isPoseedorPendienteR) {
        skipPopup = true;
      }
    }

    if (!skipPopup) {
      Swal.fire({
        title: 'Información no guardada',
        text: '¿Desea cerrar sin guardar los cambios?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, cerrar',
        cancelButtonText: 'No, volver'
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.searchFormState) {
            sessionStorage.setItem('holdersCvfInvoicesSearchForm', JSON.stringify(this.searchFormState));
            console.log('[HoldersCvfDetail cerrar] Guardado searchFormState en sessionStorage');
          }
          this.navigateBack();
        }
      });
    } else {
      if (this.searchFormState) {
        sessionStorage.setItem('holdersCvfInvoicesSearchForm', JSON.stringify(this.searchFormState));
        console.log('[HoldersCvfDetail cerrar] Guardado searchFormState en sessionStorage');
      }
      this.navigateBack();
    }
  }

  ejecutarFinalizarCVF(): void {

    Swal.fire({
      title: '¿Finalizar CVF?',
      text: 'El CVF cambiará a estado FINALIZADO y no podrá modificarse',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, finalizar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerSrv.loadingShow();

        this.cvfService.finalizarCvf(this.id).subscribe({
          next: () => {
            this.cvfData.estado = 'FINALIZADO';
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar('CVF finalizado correctamente', 'success');
            setTimeout(() => {
              this.navigateBack();
            }, 1500);
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackbarSrv.showSnackBar('Error al finalizar el CVF', 'error');
          }
        });
      }
    });
  }

  controlHasError(controlName: string, errorName: string): boolean {
    return false;
  }

  isCvfPendiente(): boolean {
    return this.cvfData?.estado?.id === 1;
  }

  isCvfPendienteFirmaOFirmado(): boolean {
    return this.cvfData?.estado?.id === 6 || this.cvfData?.estado?.id === 7;
  }

  canConfirm(): boolean {
    if (this.isCvfPoseedor()) {
      return this.canViewResource('PO-POSEEDOR') && this.isCvfPendiente();
    }
    return this.canViewResource('PO-GESTOR') && this.isCvfPendiente();
  }

  isCvfComplete(): boolean {
    if (!this.cvfData?.combinaciones) {
      return false;
    }

    if (this.cambiosSinGuardar) {
        return false;
    }

    if (this.isGestorNoRegistradoPendiente()) {
      const rs = this.cvfData?.gestorResiduos?.razonSocial;
      const doc = this.cvfData?.gestorResiduos?.codigoDocumento;
      const dir = this.getDireccionFisicaGestor(); // Usa el método que verifica ambas (nativa y manual)
      
      const completos = !!(rs && rs.trim() !== '' && doc && doc.trim() !== '' && dir && dir.trim() !== '');
      
      if (!completos || this.datosGestorModificados) {
        return false;
      }
    }

    for (const combinacion of this.cvfData.combinaciones) {
      if (combinacion.tipoOperacion === 'D') {
        const hasCantidad = combinacion.cantidadTotal !== null && combinacion.cantidadTotal !== undefined && combinacion.cantidadTotal > 0;
        const hasDestino = combinacion.operacionGestionDestino && combinacion.operacionGestionDestino.toString().trim() !== '';
        if (!hasCantidad || !hasDestino) return false;
      } else if (combinacion.tipoOperacion === 'R') {
        if (combinacion.isLoaded) {
          const valR = this.validarCombinacionTipoR(combinacion);
          if (!valR.valido) return false;
        }
      }
    }
    return true;
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  isCombinationComplete(combinacion: any): boolean {
    const isEditingThisRow = (this.combinacionEnEdicion === combinacion.id);
    // Si se está editando esta fila y hay cambios sin guardar, no mostramos el check
    if (isEditingThisRow && this.cambiosSinGuardar) {
        return false;
    }

    if (combinacion.tipoOperacion === 'D') {
        // En tipo D, basta con que el campo destino tenga valor
        return (combinacion.operacionGestionDestino && combinacion.operacionGestionDestino.toString().trim() !== '');
    } else if (combinacion.tipoOperacion === 'R') {
        // En tipo R, validamos el balance de cantidades
        if (!combinacion.isLoaded) {
            // Si el backend no tiene detalle cargado pero todo está a 0 (y es válido)
            if (this.isCvfPoseedor() && this.validarCombinacionTipoRPoseedorNoCargada(combinacion)) {
                return true;
            }
             return (combinacion.cantidadTotal > 0 && Math.abs(this.calcularCantidadRestanteGlobal(combinacion)) < 0.001);
        }
        // Si hay detalles cargados, usamos la validación específica
        return this.validarCombinacionTipoR(combinacion).valido;
    }
    return true; 
  }

  validarCombinacionTipoRPoseedorNoCargada(combinacion: any): boolean {
      if(!combinacion.materialesValorizados || combinacion.materialesValorizados.length === 0) return false;
      let balanceValido = true;
      for (const material of combinacion.materialesValorizados) {
             const algunDestinoRelleno = 
                (material.reciclado?.espanaCaOrigen?.cantidad > 0) ||
                (material.reciclado?.espanaOtraCa?.cantidad > 0) ||
                (material.reciclado?.eu?.cantidad > 0) ||
                (material.reciclado?.fueraUe?.cantidad > 0);
                
             if (algunDestinoRelleno && !material.operacionDestinoCode) {
                 balanceValido = false;
                 break;
             }

             const isD = this.isTipoD(material);
             if (isD && !material.operacionDestinoDesc) {
                 balanceValido = false;
                 break;
             }

             const totalDesglose = this.calcularTotalDesgloseMaterial(material);
             if (Math.abs(material.cantidad - totalDesglose) > 0.00001) {
                 balanceValido = false;
                 break;
             }
      }
      return balanceValido;
  }

  isCvfPoseedor(): boolean {
    return !!this.cvfData?.poseedor;
  }

  isGestorRegistrado(): boolean {
    return !!this.cvfData?.gestorResiduos?.id;
  }

  isGestorPendienteDatosObligatorios(): boolean {
    return this.isGestorRegistrado() && this.cvfData?.gestorResiduos?.gestoresResiduosEstado?.id === 1;
  }

  isGestorNoRegistradoPendiente(): boolean {
    return this.isCvfPoseedor() && (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios()) && this.isCvfPendiente();
  }

  getDireccionFisicaGestor(): string {
    // Solo aplica si es un CVF de Poseedor
    if (this.cvfData?.poseedor) {
       if (this.cvfData?.gestorResiduos?.domicilios) {
           let direccion = this.cvfData?.gestorResiduos.domicilios.find((d: any) => d.tipoDireccion?.id === 5);
           if (direccion && this.isGestorPendienteDatosObligatorios() && (!direccion.fullAddress || direccion.fullAddress.trim() === '')) {
               direccion = undefined;
           }
           if (direccion) {
               // Construir dirección con el formato: [nombreVia] [numero] [bloque] [escalera] [piso] [puerta], [codigoPostal.codigoPostal] [municipio] [provincia.nombre]
               const partesVia = [
                   direccion.nombreVia,
                   direccion.numero,
                   direccion.bloque,
                   direccion.escalera,
                   direccion.piso,
                   direccion.puerta
               ].filter(Boolean).join(' ');

               const partesLugar = [
                   direccion.codigoPostal?.codigoPostal || (typeof direccion.codigoPostal === 'string' ? direccion.codigoPostal : undefined),
                   direccion.municipio?.nombre || (typeof direccion.municipio === 'string' ? direccion.municipio : undefined),
                   direccion.provincia?.nombre || (typeof direccion.provincia === 'string' ? direccion.provincia : undefined)
               ].filter(Boolean).join(' ');

               const fullAddress = [partesVia, partesLugar].filter(p => p.trim() !== '').join(', ');
               
               if (fullAddress) {
                   return fullAddress;
               }
           }
       }
       if (this.cvfData.direccionFisicaGestor && (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios())) {
           return this.cvfData.direccionFisicaGestor;
       }
    }
    return '';
  }

  getDireccionFisicaGestorForEdit(): any {
     if (this.cvfData?.gestorResiduos?.domicilios) {
       return this.cvfData.gestorResiduos.domicilios.find((d: any) => d.tipoDireccion?.id === 5);
     }
     return null;
  }

  ensureGestorDataStructure() {
    if (this.isCvfPoseedor() && (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios())) {
      if (!this.cvfData.gestorResiduos) {
        this.cvfData.gestorResiduos = {};
      }
      
      // Cargar datos manuales guardados si existen en el nivel superior
      if (this.cvfData.razonSocialGestor && !this.cvfData.gestorResiduos.razonSocial) {
          this.cvfData.gestorResiduos.razonSocial = this.cvfData.razonSocialGestor;
      }
      if (this.cvfData.codigoDocumentoGestor && !this.cvfData.gestorResiduos.codigoDocumento) {
          this.cvfData.gestorResiduos.codigoDocumento = this.cvfData.codigoDocumentoGestor;
      }

      if (!this.cvfData.gestorResiduos.domicilios) {
        this.cvfData.gestorResiduos.domicilios = [];
      }
      let direccion = this.cvfData.gestorResiduos.domicilios.find((d: any) => d.tipoDireccion?.id === 5);
      
      if (!direccion) {
        const savedAddress = this.cvfData.direccionFisicaGestor || '';
        direccion = { tipoDireccion: { id: 5 }, fullAddress: savedAddress };
        this.cvfData.gestorResiduos.domicilios.push(direccion);
      }
    }
  }

  shouldShowGestorManualInput(): boolean {
    return !this.isGestorRegistrado() && !this.canViewResource('PO-ENV-GEST') && this.isCvfPendiente();
  }

  shouldShowGestorAddressManualInput(): boolean {
    if (this.isGestorRegistrado() && this.isGestorPendienteDatosObligatorios()) {
      const direccion = this.cvfData?.gestorResiduos?.domicilios?.find((d: any) => d.tipoDireccion?.id === 5);
      const isDireccionFisicaEmpty = direccion && (!direccion.fullAddress || direccion.fullAddress.trim() === '');
      // If it's valid physically but completely empty in text, we treat it as needing input
      if (direccion && (direccion.id || direccion.municipio || direccion.codigoPostal) && !isDireccionFisicaEmpty) {
        return false;
      }
    }
    return (!this.isGestorRegistrado() || this.isGestorPendienteDatosObligatorios()) && !this.canViewResource('PO-ENV-GEST') && this.isCvfPendiente();
  }

  isGestorDisplayVisible(): boolean {
    return this.isGestorRegistrado() || this.canViewResource('PO-ENV-GEST') || !this.isCvfPendiente();
  }

  subirCVF(element: any) {
    const dialogRef = this.dialog.open(HoldersCvfSignedUploadDialogComponent, {
      width: '800px',
      data: { info: element }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.cargarDatosCvf();
      }
    });
  }

  descargarCertificadoCVF(element: any){
    this.spinnerSrv.loadingShow();
    this.cvfService.crearCertificado(element?.id, 'response')
      .subscribe({
        next: (res: any) => {
          const filename = this.downloadService.getFileName(
            res.headers,
            'CVF.pdf'
          );
          this.downloadService.downloadBlob(res.body as any, filename!);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        }
      });
  }

  isGestorManualDataValid(): boolean {
    let isValid = true;
    if (this.shouldShowGestorAddressManualInput() && (!this.cvfData?.direccionFisicaGestor || this.cvfData.direccionFisicaGestor.trim() === '')) {
      this.snackbarSrv.showSnackBar('La dirección física del gestor es obligatoria.', 'error');
      isValid = false;
    } else if (this.shouldShowGestorManualInput()) {
      if (!this.cvfData?.gestorResiduos?.razonSocial || this.cvfData.gestorResiduos.razonSocial.trim() === '') {
        this.snackbarSrv.showSnackBar('La Razón Social del gestor es obligatoria.', 'error');
        isValid = false;
      } else if (!this.cvfData?.gestorResiduos?.codigoDocumento || this.cvfData.gestorResiduos.codigoDocumento.trim() === '') {
        this.snackbarSrv.showSnackBar('El Documento del gestor es obligatorio.', 'error');
        isValid = false;
      }
    }
    return isValid;
  }

  guardarDatosGestorManual(): void {
    if (this.canViewResource('PO-ENV-GEST') || !this.isGestorManualDataValid()) {
      return;
    }
    this.spinnerSrv.loadingShow();

    const payload: any = {
      ...this.cvfData,
      razonSocialGestor: this.cvfData.gestorResiduos?.razonSocial,
      codigoDocumentoGestor: this.cvfData.gestorResiduos?.codigoDocumento,
      direccionFisicaGestor: this.cvfData.direccionFisicaGestor
    };

    if (!payload.gestorResiduos?.id) {
      payload.gestorResiduos = null;
    }

    this.cvfService.editById5(this.id, payload).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.datosGestorModificados = false;
        this.snackbarSrv.showSnackBar('Datos del gestor guardados correctamente', 'success');
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackbarSrv.showSnackBar('Error al guardar los datos del gestor', 'error');
      }
    });
  }

  getPoseedorTableStyle(): any {
      return {
          'padding-bottom.px': 170
      };
  }

  getEstadoTooltip(): string {
    if (this.canViewResource('PO-ENV-GEST')) {
      if (this.isCvfPoseedor()) {
        switch (this.cvfData?.estado?.id) {
          case 1:
            return 'CVF pendiente de cumplimentación.';
          case 6:
            return 'Datos del CVF registrados por el poseedor. CVF firmado por el gestor pendiente de carga.';
          case 7:
            return 'CVF firmado y cargado. CVF pendiente de finalización por el poseedor.';
          case 2:
            return 'CVF finalizado. Pendiente de revisión por ENVALORA.';
          default:
            return '';
        }
      } else {
        switch (this.cvfData?.estado?.id) {
          case 1:
            return 'CVF pendiente de cumplimentación.';
          case 2:
            return 'CVF finalizado. Pendiente de revisión por ENVALORA.';
          default:
            return '';
        }
      }
    } else {
      if (this.isCvfPoseedor()) {
        switch (this.cvfData?.estado?.id) {
          case 1:
            return 'Complete la información del CVF correspondiente a este gestor.';
          case 6:
            return 'Los datos del CVF ya no son editables.\nDescargue el CVF para su firma por el gestor y súbalo posteriormente a la plataforma.';
          case 7:
            return 'CVF firmado por el gestor. Debe finalizar el CVF para cerrar el proceso.';
          case 2:
            return 'CVF finalizado. Pendiente de revisión por ENVALORA.';
          default:
            return '';
        }
      } else {
        switch (this.cvfData?.estado?.id) {
          case 1:
            return 'Complete la información del CVF.';
          case 2:
            return 'CVF finalizado. Pendiente de revisión por ENVALORA.';
          default:
            return '';
        }
      }
    }
  }
}
